import { render, staticRenderFns } from "./RabbeyTable4.vue?vue&type=template&id=66749150&"
import script from "./RabbeyTable4.vue?vue&type=script&lang=js&"
export * from "./RabbeyTable4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports